

import { NgModule } from '@angular/core';
import { CarouselModule } from 'tn-custom-primeng/carousel';
import { TnxSharedModule } from 'tnx-shared';
import { HomeComponent } from './home.component';
import { HomeRoutes } from './home.routing';
import { MenuMobileComponent } from './menu-mobile/menu-mobile.component';

export function declaration() {
    return [HomeComponent, MenuMobileComponent];
}

@NgModule({
    imports: [
        TnxSharedModule,
        CarouselModule
    ],
    declarations: declaration(),
    exports: declaration()
})
export class HomeModule {
}

@NgModule({
    imports: [HomeModule, HomeRoutes],
    exports: [HomeModule]
})
export class HomeWithRouteModule {
}
